import { render, staticRenderFns } from "./SolubleDrinks.vue?vue&type=template&id=29dd3a89&scoped=true&"
import script from "./SolubleDrinks.vue?vue&type=script&lang=js&"
export * from "./SolubleDrinks.vue?vue&type=script&lang=js&"
import style0 from "./SolubleDrinks.vue?vue&type=style&index=0&id=29dd3a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd3a89",
  null
  
)

export default component.exports